import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=2c3510bb&scoped=true&"
import script from "./ReportTable.vue?vue&type=script&lang=js&"
export * from "./ReportTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportTable.vue?vue&type=style&index=0&id=2c3510bb&lang=scss&scoped=true&"
import style1 from "./ReportTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3510bb",
  null
  
)

export default component.exports